import PropTypes from "prop-types"

import { Box, Grid, Fade, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const ProgressComponent = ({ loading, type = "outside", text = "", color, backgroundColor = "rgba(128, 120, 120, 0.2)", marginTop = "10px" }) => (
    <Fade
        in={loading}
        unmountOnExit
    >
        {
            type === "outside" ? (
                <Box sx={{ position: "fixed", zIndex: 10000, top: 0, left: 0, height: "100vh", width: "100vw", display: "flex", alignItems: "center", justifyContent: "center" }} >
                    <Grid sx={{ height: "100%", width: "100%", backgroundColor, position: "absolute", }} />
                    <CircularProgress />
                </Box>
            ) : (
                <Box sx={{ position: "absolute", zIndex: 10000, height: "100%", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} >
                    <Grid sx={{ height: "100%", width: "100%", backgroundColor, position: "absolute", borderRadius: "4px" }} />
                    <CircularProgress sx={{ color: (theme) => color ?? theme.palette.primary.main }} />
                        {
                            text &&  <Typography sx={{ color: "#1877F2", marginTop }}>{text ?? ""}</Typography>
                        }
                   
                </Box>
            )
        }
    </Fade>
)


ProgressComponent.propTypes = {
    loading: PropTypes.bool,
    type: PropTypes.string,
    text: PropTypes.string,
    backgroundColor: PropTypes.string,
    marginTop: PropTypes.string,
}
export default ProgressComponent